<template>
<v-card
  class="mx-auto my-4  errorCard"
  rounded="lg"
  max-width="500"
  elevation="0"
  density="comfortable"
  style="background: linear-gradient(to top right, rgba(255, 255, 255, 0.1), rgba(14, 151, 210, 0.15));"
>

    <v-card-text class="text-center pa-8">
      <div align="center">
        <v-img src="@/assets/NoDataImg.svg" width="200" height="200"></v-img>
      </div>

      <h6 class="text-h6 mb-3 font-weight-bold text-red defaultFont">
        {{ noDataText }}
      </h6>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    noDataText: String,
  },
  data() {
    return {};
  },
  methods: {

  },
};
</script>
<style scoped>
.errorCard {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}


</style>
